import { StylesConfig } from "react-select";
import { _window } from "../../app-constants";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  BTapiUrl: process.env.REACT_APP_BT_BASE_URL,
  BTpublishableKey: process.env.REACT_APP_BT_AUD_PUBLISHABLE_KEY,
  BTproductId: process.env.REACT_APP_BT_PRODUCT_ID,
  BTaffiliatedId: process.env.REACT_APP_BT_AFFILIATED_ID,
  isSandBoxMode: parseInt(process.env.REACT_APP_BT_IS_SANDBOX || "0"),
  UKTelephone: _window?.BFPlugin?.bt?.Telephone || "+44 (78) 2202 7401",
  EUTelephone: _window?.BFPlugin?.bt?.Telephone || "+(32) 2881 0125",
  UKEmail: _window?.BFPlugin?.bt?.Email || "businesstravel@battleface.com",
  EUEmail: _window?.BFPlugin?.bt?.Email || "businesstravel@battleface.com",
};

export const btCurrencyProductIds = {
  BTGBPProductId: process.env.REACT_APP_BT_GBP_PRODUCT_ID,
  BTEURProductId: process.env.REACT_APP_BT_EUR_PRODUCT_ID,
  BTUSDProductId: process.env.REACT_APP_BT_USD_PRODUCT_ID,
  BTEUProductId: process.env.REACT_APP_EU_PRODUCT_ID,
  BTAUDProductId: process.env.REACT_APP_BT_AUD_PRODUCT_ID,
};

export const noOfEmployee = [
  { value: "2-10", label: "2-10" },
  { value: "11-25", label: "11-25" },
  { value: "26-50", label: "26-50" },
  { value: "50-99", label: "50-99" },
  { value: "100+", label: "100+" },
];

export const currencyDropDown = [
  {
    value: "GBP",
    label: "GBP",
  },

  {
    value: "EUR",
    label: "EUR",
  },

  {
    value: "USD",
    label: "USD",
  },
];

// DD/MM/yyyy
export const formatTripDates = (date: Date | null) => (date ? date.toLocaleDateString("en-GB") : "");

export const businessTravelDocs: { [Key: string]: string } = {
  customQuote: _window?.BFPlugin?.bt?.customQuote || "https://www.battleface.com/en-gb/business-group-application",
  excludedDestinations:
    _window?.BFPlugin?.bt?.excludedDestinations ||
    `Afghanistan, Belarus, Central African Republic, Chechnya, Crimea, Democratic Republic of Congo, Cuba,
          Iran, Iraq, Israel, Lebanon, Libya, Nigeria, North Korea, Palestine, Russian Federation, Somalia, South Sudan,
          Sudan, Syria, Ukraine, Venezuela and Yemen.`,
  importantNote: _window?.BFPlugin?.bt?.importantNote || '',
  warningMessage:
    _window?.BFPlugin?.bt?.warningMessage ||
    "You have a duty to take reasonable care to answer questions fully and accurately. This duty exists when applying for cover and throughout the entire duration of the insurance.",
  governmentTravelAdvisory:
    _window?.BFPlugin?.bt?.governmentTravelAdvisory ||
    "This insurance product covers destinations worldwide, including countries under government essential   and non-essential travel advisories. For the latest travel advice please visit your local government website.",
};

export const PreviewPolicyAU: any = {
  AUD: _window?.BFPlugin?.bt?.AUDPreviewPolicy ||
    "https://documents.battleface.com/policy/australian-business-travel-policy-document.pdf",
}

export const businessTravelAUDocs: { [Key: string]: string } = {
  privacyPolicy: _window?.BFPlugin?.bt?.privacyPolicy || "https://www.battleface.com/en-au/privacy-policy",
  termsAndConditions: _window?.BFPlugin?.bt?.termsAndConditions || "https://www.battleface.com/en-au/terms-conditions",
  cookiePolicy: _window?.BFPlugin?.bt?.cookiePolicy || "https://www.battleface.com/en-au/cookie-policy",
  MarketDetermination:
    _window?.BFPlugin?.bt?.MarketDetermination || "https://documents.battleface.com/tmd/australian-business-travel-tmd-document.pdf", 
};


export const benefitSummaryTableAU = [
  {
    name: "Emergency Medical, additional travel expenses and repatriation",
    benefit: "Unlimited (Maximum of 12 months treatment)",
    description:
      "Cover for emergency medical treatment arising during a trip. Cover also includes additional travel expenses to transport the insured person to the nearest appropriate medical facility or back to their home country. Emergency dental treatment is included up to $2,000.",
  },
  {
    name: "Emergency Medical treatment in country of residence",
    benefit: "Up to $20,000",
    description:
      "Where legally permitted, we cover medical treatment incurred in the insured person’s country of residence within four weeks of returning from a covered trip.",
  },
  {
    name: "Funeral Expenses Overseas or Repatriation of remains",
    benefit: "Up to $10,000",
    description: "Cover for burial or cremation overseas, or the reasonable costs of returning the insured person’s remains to their country of residence following death during a trip",
  },

  {
    name: "Hospital and Cabin confinement",
    benefit: "$75 per day (up to a maximum of $7,500) ",
    description:
      "Daily benefit payable for each full 24hour period the insured person is hospitalised or medically confined while overseas as a result of illness or injury during a trip.",
  },
  {
    name: "Search and Rescue",
    benefit: "Up to $20,000",
    description:
      "Cover for essential search and rescue costs incurred if an insured person goes missing during a trip and authorised rescue or police authorities initiate a search or rescue operation.",
  },
  {
    name: "Trip Cancellation and Interruption",
    benefit: "Up to $10,000 (per incident aggregate limit of $20,000)",
    description: "Cover for prepaid, nonrefundable trip costs if an insured person needs to cancel their trip before departure or interrupt their trip due to an insured event",
  },
  {
    name: "Replacement staff",
    benefit: "Up to $2,500",
    description: "Cover for additional travel costs incurred to send a replacement staff member if an insured person is unable to commence or complete their assignment due to an insured event.",
  },

  {
    name: "Travel Delay",
    benefit: "$75 per 6 hours (up to a maximum of $3,000)",
    description: "Cover towards reasonable accommodation and out of pocket expenses if an insured person experiences an unexpected travel delay of more than six hours during a trip.",
  },

  {
    name: "Accidental Death and Permanent Total Disablement",
    benefit: "$50,000 (per incident aggregate limit of $100,000) ",
    description: "Cover if an insured person suffers accidental bodily injury during a trip that directly results in death or permanent total disablement.",
  },
  {
    name: "Personal Liability (incl Legal Expenses) ",
    benefit: "Up to $2,500,000",
    description: "Cover for legal liability arising from negligence during a trip that causes unintentional personal injury to a third party or damage to their property.",
  },
  {
    name: "Luggage, Personal Effects and Business Equipment",
    benefit: "Up to $10,000 (limit of $5,000 for Business Equipment and $2,000 per item) ",
    description: "Cover for luggage, personal effects and business equipment that are stolen, accidentally lost or damaged during a trip, subject to item limits.",
  },
  {
    name: "Delayed baggage",
    benefit: "Up to $500 after 6-hour delay",
    description:
      "Reimbursement for essential purchases if the carrier confirms that the insured person’s checked baggage is delayed or misplaced.",
  },
  {
    name: "Rental Vehicle Excess",
    benefit: "Up to $6,000",
    description:
      "Cover for the rental vehicle excess payable by the insured person following theft of, or damage to, a rental vehicle while in their possession during a trip.",
  },
];

// for react select dropdown options styling
export const colourStyles: StylesConfig<any> = {
  option: (styles, { isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isDisabled ? undefined : isSelected ? "#F4F4F4" : isFocused ? "#F4F4F4" : undefined,
      color: isSelected ? "black" : undefined,
      ":active": {
        ...styles[":active"],
        backgroundColor: isSelected ? "#F4F4F4" : "#F4F4F4",
      },
    };
  },
};

export const getProduct = (currency: string) => {
  switch (currency) {
    case "GBP":
      return btCurrencyProductIds.BTGBPProductId;
    case "EUR":
      return btCurrencyProductIds.BTEURProductId;
    case "AUD":
      return btCurrencyProductIds.BTAUDProductId;
    default:
      return btCurrencyProductIds.BTUSDProductId;
  }
};
